module.exports = __webpack_public_path__ + "media/pricing/Dashboards-2638d4a0.svg";